import React, {Component} from "react"

import {Occasion} from "@irati/types"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"

import Tooltip, {Tip} from "./Tooltip"
import {IconWrapper} from "./styled"

interface Props extends InjectIntl {
  occasion: Occasion
}

class OccasionIcon extends Component<Props> {
  render() {
    const {occasion, formatMessage} = this.props
    if (!occasion || !occasion.icon) {
      return null
    }
    const occasionLabel = occasion.name
    const occasionAlt = occasion.icon.alt
    const occasionHref = occasion.icon.href
    const occasionName = occasion.default ? <FormattedMessage id={occasionLabel} /> : occasionLabel
    const occasionImgAlt = occasion.default ? <FormattedMessage id={occasionAlt} /> : occasionAlt

    return (
      <Tooltip placement="top" tip={<Tip id={`${occasionName}Tooltip`}>{occasionName}</Tip>}>
        <IconWrapper archived={occasion.archived}>
          <img src={occasion.default ? formatMessage({id: occasionHref}) : occasionHref} alt={occasionImgAlt} />
        </IconWrapper>
      </Tooltip>
    )
  }
}

export default injectIntl(OccasionIcon)
